/**
 * Texts of the on-screen battle controls of touch screens (port addition: the original was played with a keyboard and a
 * mouse). As everywhere in the game, the Russian text is the source and the translation key (src/game/runtime/i18n.ts);
 * every string has a catalogue entry in uk / en (tools/i18n/extra.json). The shell translates them (touch-controls.ts
 * gets them from mobile-port.ts battleControls).
 */

/** A strike waits for its target: a tap on the map sets it. */
export const TT_TARGET_PICK = 'Коснитесь карты, чтобы выбрать цель';
/** A teleport or a girder waits for its place. */
export const TT_PLACE_PICK = 'Коснитесь карты, чтобы выбрать место';
/** The target is set (the game's cursor is there): the fire button confirms it. */
export const TT_TARGET_READY = 'Подтвердите кнопкой огня';
/**
 * A strike's side buttons (from the left / from the right). `{left}` / `{right}` / `{fire}` in a hint are drawn as the
 * icons of those buttons now (touch-controls.ts): the side buttons of a target mode are not arrows.
 */
export const TT_STRIKE_SIDE = 'Кнопки {left} {right} меняют направление удара';
/** A girder's side buttons (its 16 shapes). */
export const TT_GIRDER_TURN = 'Кнопки {left} {right} поворачивают балку';
/** The worm choice utility (Enter: the next worm, Escape: this one). */
export const TT_WORM_CHOICE = 'Кнопка {right} — следующий червяк, кнопка {fire} — выбрать';
/** A utility (a medikit, low gravity, invisibility, more time...): the fire button uses it. */
export const TT_USE = 'Кнопка огня — использовать';
/** The utility that skips the turn. */
export const TT_USE_SKIP = 'Кнопка огня — пропустить ход';
/** A sheep or an old woman on its way (Space explodes it). */
export const TT_DETONATE = 'Кнопка огня — взорвать';
/** A jet pack in flight. */
export const TT_JET_PACK = 'Стрелки управляют полётом, кнопка огня — выключить ранец';
/** The parachute is selected on the ground: it opens in a jump only. */
export const TT_PARACHUTE_JUMP = 'Прыгните и нажмите кнопку огня в воздухе';
/** An open parachute. */
export const TT_PARACHUTE = 'Стрелки управляют спуском, кнопка огня — сложить парашют';
/** A blow torch or a drill at work. */
export const TT_TOOL_STOP = 'Кнопка огня — остановить';
/** The weapon sheet on a touch screen: a long press shows a weapon's description (its hover) without picking it. */
export const TT_SHEET = 'Удерживайте палец на оружии, чтобы прочитать описание';
/** The weapon sheet's description while no weapon is held and the worm has none. */
export const TT_SHEET_PICK = 'Коснитесь оружия, чтобы взять его в руки.';
/** The question before the surrender button of a battle gives it up on a touch screen. */
export const TT_SURRENDER_QUESTION = 'Завершить бой? Он будет засчитан как поражение.';
/** The surrender button's own tooltip text. */
export const TT_SURRENDER_YES = 'Завершить бой';
export const TT_SURRENDER_NO = 'Продолжить бой';
/** The roulette's diamond bet on a touch screen asks first (its question: the bet's own text and "?"). */
export const TT_BET_YES = 'Поставить';
export const TT_BET_NO = 'Отмена';
